import { Modal } from "../../../components";
import SumSubKyc from "./SumSubKyc";
import React, { FC } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onPrev?: () => void;
};

const SumSubKycModal: FC<Props> = ({ isOpen, onClose, onSubmit, onPrev }) => {
  return (
    <Modal
      title=""
      isOpen={isOpen}
      onClose={onClose}
      className="cx-py-4 cx-w-full"
    >
      <SumSubKyc onSubmit={onSubmit} onPrev={onPrev} />
    </Modal>
  );
};

export default SumSubKycModal;
